/*
 * Search box inside long facet lists (Designer on /dresses has 25+ values).
 *
 * Event delegation on document, because the theme replaces the whole sidebar
 * markup after every filter change and the inputs are re-created each time.
 */
(function () {
  'use strict';

  const INPUT = '[data-filter-search]';
  const LIST = '[data-filter-search-list]';
  const ITEM = '.sidebar__item';
  const LABEL = '[data-filter-value-label]';
  const EMPTY_CLASS = 'filter-group__search-empty';

  function listFor(input) {
    const wrapper = input.closest('.filter-group__search');
    return wrapper ? wrapper.nextElementSibling : null;
  }

  function emptyMessage(list, input) {
    let el = list.parentElement.querySelector(`.${EMPTY_CLASS}`);
    if (!el) {
      el = document.createElement('p');
      el.className = EMPTY_CLASS;
      el.setAttribute('role', 'status');
      el.hidden = true;
      el.textContent = input.dataset.noResults || 'No matches';
      list.insertAdjacentElement('afterend', el);
    }
    return el;
  }

  function applySearch(input) {
    const list = listFor(input);
    if (!list || !list.matches(LIST)) return;

    const term = input.value.trim().toLowerCase();
    const items = list.querySelectorAll(ITEM);
    let matches = 0;

    list.classList.toggle('is-searching', term.length > 0);

    items.forEach((item) => {
      if (!term) {
        item.removeAttribute('data-search-match');
        return;
      }
      const label = item.querySelector(LABEL);
      const text = (label ? label.textContent : item.textContent).trim().toLowerCase();
      const hit = text.indexOf(term) !== -1;
      if (hit) {
        item.setAttribute('data-search-match', '');
        matches += 1;
      } else {
        item.removeAttribute('data-search-match');
      }
    });

    const empty = emptyMessage(list, input);
    empty.hidden = !term || matches > 0;
  }

  document.addEventListener('input', (event) => {
    const input = event.target;
    if (input && input.matches && input.matches(INPUT)) applySearch(input);
  });

  // Pressing Enter in the box must not submit the surrounding filter form.
  document.addEventListener('keydown', (event) => {
    const input = event.target;
    if (event.key === 'Enter' && input && input.matches && input.matches(INPUT)) event.preventDefault();
  });
})();
